import React, { useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import SplashPage from '../SplashPage';
import { useNavigate, useParams } from "react-router-dom";
import { Card, Col, Container, Row, Button } from "react-bootstrap";
import { BsQuestionLg } from "react-icons/bs";
import { TbCoins, TbFlame, TbTruckDelivery } from "react-icons/tb";
import { SlEnergy } from "react-icons/sl";
import { MdOutlineOilBarrel, MdOutlineSolarPower } from "react-icons/md";
import "react-pdf/dist/esm/Page/TextLayer.css";
import PdfModal from "../../components/shared/PdfModal";
import ElvDetailsCard from "../../components/elvs/ElvDetailsCard";
import { useQuery } from "react-query";
import ElvLeerstandModal from "../../components/elvs/ElvLeerstandModal";
import ElvTeilVorschreibungModal from "../../components/elvs/ElvTeilvorschreibungModal";
import MissingInvoiceModal from "../../components/elvs/ElvMissingInvoiceModal";
import DetailedList from "../../components/shared/DetailedList";
import { FaSwimmingPool } from "react-icons/fa";
import { CgSandClock } from "react-icons/cg";
import { useAuthState } from "../../context/AuthContext";
import ErrorPage from "../ErrorPage";
import ContractCard from "../../components/elvs/details/ContractCard";
import ActionsCard from "../../components/elvs/details/ActionsCard";
import DocumentsCard from "../../components/elvs/details/DocumentsCard";
import TicketsCard from "../../components/elvs/details/TicketsCard";

/**
 * ElvDetailPage
 * 
 * get single Elv details and on click gets Abrechnung, Poolrechnung,
 * Vorschreibung from that Elv.
 * 
 * @returns None
 */
const ElvDetailPage = () => {

    const API = new PrivateApi(); // API calls
    const { user } = useAuthState();
    const { elv_id } = useParams(); // elv id paramater passed
    const navigate = useNavigate();


    // API call 
    const { data, error, isLoading } = useQuery(["GET_ELV_DETAILS_QUERY", elv_id], () => API.get_ElvsDetail(elv_id), {
        staleTime: Infinity,
        enabled: elv_id !== null,
    });


    // GUI
    if (isLoading) return <SplashPage />
    if (error) return <ErrorPage error={error} />

    return (
        <Container>
            <Row className="align-items-center">
                <Col>
                    <h3>Energieliefervertrag</h3>

                </Col>
                <Col className="text-end">
                    <Button
                        onClick={() => navigate(`${user.x_is_house_management ? `/hw/dashboard/energieliefervertraege/zeitverlauf/${data.elv.x_kunde_id[0]}/` : '/dashboard/zeitverlauf/'}${data.elv.x_anlage_id.x_studio_field_mWMGR}`)}
                        className="btn-energo rounded-pill"
                    >
                        <CgSandClock size={25} /> Ansicht: Zeitverlauf
                    </Button>
                </Col>
            </Row>

            <Row className="mt-5">
                <Col>
                    <ContractCard elv={data.elv} energieprodukt={data.energieprodukt} />
                </Col>
            </Row>

            <Row className="mt-5">
                <Col>
                    <ActionsCard elv={data.elv} energieprodukt={data.energieprodukt} tickets={data.tickets} />
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" md="6" xl="6">
                    <DocumentsCard
                        abrechnungen={data.abrechnungen}
                        vorschreibungen={data.vorschreibungen}
                        poolrechnungen={data.poolrechnungen}
                    />
                </Col>
                <Col xs="12" md="6" xl="6">
                    <TicketsCard tickets={data.tickets} />
                </Col>
            </Row>

        </Container>
    )
}

export default ElvDetailPage;